import '../../style/index.less'; // style dependencies
// deps-lint-skip: tooltip, popover

import '../../popover/style';
import '../../button/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/popconfirm/style/index.js
// module id = 1473
// module chunks = 0